import { render, staticRenderFns } from "./CpfVerification.vue?vue&type=template&id=292beff0"
import script from "./CpfVerification.vue?vue&type=script&lang=js"
export * from "./CpfVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports